import { render } from "./template7.vue?vue&type=template&id=10f76bc2"
import script from "./template7.vue?vue&type=script&lang=js"
export * from "./template7.vue?vue&type=script&lang=js"

import "./template7.vue?vue&type=style&index=0&id=10f76bc2&lang=scss"

import exportComponent from "C:\\Users\\john doe\\Documents\\Venice\\vnc\\AgendaBuilder\\agenda\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__